module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"tooltip":"Wykres prezentuje ranking produktów według średniej dostępności ofert produktów producenta w sklepach wyświetlanych w widgecie (ustawienia domyślnie). Aby sprawdzić liczbę ofert w pozostałych sklepach, użyj filtra Sklep."}}')
  delete Component.options._Ctor
}
